import { Back } from '@/components/Back'
import { Button } from '@/components/Button'
import { Field } from '@/components/form/Field'
import { FormGroup } from '@/components/form/FormGroup'
import { Title } from '@/components/Title'
import { RegistrationModel } from '@/core/services/Auth/models/AuthModel'
import { Memo } from '@/hoc/Memo'
import useBackendError from '@/hooks/useBackendError'
import yup from '@/utils/yup-extended'
import { cn } from '@bem-react/classname'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { FC, useCallback } from 'react'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const cnCustomerInfo = cn('CustomerInfo')

import './styles/CustomerInfo.scss'

export const CustomerInfo: FC = Memo(() => {
  const { t } = useTranslation('translation')
  const [setBackendError, fieldsError] = useBackendError()

  const CustomerInfoSchema = yup.object().shape({
    name: yup.string().trim().required(t('Name is a required field')),
    mobileTelephone: yup
      .string()
      .trim()
      .when({
        is: (val: string) => val.length,
        then: yup.string().trim().isValidPhone(t('isValidPhone')),
      })
      .nullable(true),
    email: yup
      .string()
      .trim()
      .email(t('Email is not correct'))
      .required(t('Email is a required field')),
    companyAddress: yup.string().trim(),
  })

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<RegistrationModel>({
    mode: 'onChange',
    resolver: yupResolver(CustomerInfoSchema),
  })

  const login = useCallback((data: RegistrationModel) => {
    try {
      // const res = await dispatch(updateLicenseThunk(data)).unwrap()
      // if (res) {
      //   dispatch(
      //     setToast({
      //       type: ToastType.success,
      //       message: t('Customer data successfully updated'),
      //     }),
      //   )
      //   onClose()
      console.log('12', data)

      // }
    } catch (errors) {
      setBackendError(errors)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>{t('Customer Info')} | Registration</title>
      </Helmet>
      <div className={cnCustomerInfo()}>
        <Back />
        <form className={cnCustomerInfo('form')} onSubmit={handleSubmit(login)}>
          <Title className={cnCustomerInfo('title')}>
            {t('Customer Info')}
          </Title>
          <div className={cnCustomerInfo('text')}>
            {t('Please enter the Customer Info (optional)')}
          </div>
          <FormGroup className={cnCustomerInfo('grid')}>
            <Field
              {...register('name')}
              placeholder={t('Name*')}
              label={t('Name')}
              required
              errors={
                (errors.name && errors.name.message) ||
                (fieldsError && fieldsError.name && fieldsError.name.message)
              }
            />
            <Field
              {...register('email')}
              placeholder={t('Email*')}
              label={t('Email')}
              required
              errors={
                (errors.email && errors.email.message) ||
                (fieldsError && fieldsError.email && fieldsError.email.message)
              }
            />
            <Field
              {...register('mobileTelephone')}
              placeholder={t('Phone')}
              label={t('Phone')}
              errors={
                (errors.mobileTelephone && errors.mobileTelephone.message) ||
                (fieldsError &&
                  fieldsError.mobileTelephone &&
                  fieldsError.mobileTelephone.message)
              }
            />
          </FormGroup>
          <FormGroup>
            <Field
              {...register('companyAddress')}
              placeholder={t('Address')}
              label={t('Address')}
              errors={
                (errors.companyAddress && errors.companyAddress.message) ||
                (fieldsError &&
                  fieldsError.companyAddress &&
                  fieldsError.companyAddress.message)
              }
            />
          </FormGroup>
          <Button large type={'submit'} isLoading={isSubmitting}>
            {t('Continue')}
          </Button>
        </form>
      </div>
    </>
  )
})
